import React, { useState } from "react";
import { TabContent, TabPane, Row, Col } from "reactstrap";
import countries from "../../Country/country.json";
import { useSelector, useDispatch } from "react-redux";
import { postNewOrder } from "../../redux/thunks/orderThunks";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";

const PostComponent = ({ triggerRefresh }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector((state) => state.user.user.data);
  const paymentCards = user?.bankingInfo?.paymentCards || [];
  const depositAccounts = user?.bankingInfo?.depositAccounts || [];

  const valueTemplate = (option, props) => {
    if (!option || !option.flag) return props.placeholder;
    return (
      <div className="p-dropdown-value">
        <img
          alt={option.name}
          src={option.flag}
          width="20"
          style={{ verticalAlign: "middle", marginRight: "8px" }}
        />
        <span>{t(`${option.currencyCode}.currency.label`)}</span>
      </div>
    );
  };

  const itemTemplate = (option) => {
    return (
      <div className="p-dropdown-item">
        <img
          alt={option.name}
          src={option.flag}
          width="20"
          style={{ verticalAlign: "middle", marginRight: "8px" }}
        />
        <span>{t(`${option.currencyCode}.currency.label`)}</span>
      </div>
    );
  };

  const [formState, setFormState] = useState({
    buyCurrency: "",
    sellCurrency: "",
    buyAmount: "",
    sellAmount: "",
    paymentMethod: "",
    depositAccountId: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const cleanValue =
      name === "buyAmount" || name === "sellAmount"
        ? value.replace(/[^\d.]/g, "")
        : value;
    setFormState((prev) => ({ ...prev, [name]: cleanValue }));
    console.log("formstate", formState);
  };

  const sellAmount = parseFloat(formState.sellAmount) || 0;
  const buyAmount = parseFloat(formState.buyAmount) || 0;
  const fee = sellAmount * 0.005;
  const total = sellAmount + fee;

  const handlePostOrder = () => {
    const selectedCard = paymentCards.find(
      (card) => `${card.brand} **** ${card.last4}` === formState.paymentMethod
    );
    const selectedAccount = depositAccounts.find(
      (acc) =>
        `${acc.bankName} ****${acc.accountNumber?.slice(-4)}` ===
        formState.depositAccountId
    );

    const rate = sellAmount / buyAmount;
    const orderData = {
      max: sellAmount,
      from: formState.sellCurrency,
      to: formState.buyCurrency,
      rate: rate,
      selectedCard: selectedCard || { id: null },
      selectedAccount: selectedAccount || { bankAccountId: null },
    };

    dispatch(
      postNewOrder({
        orderData,
        userId: user.id,
        email: user.email,
      })
    );
    triggerRefresh();
  };

  if (!user || !user.bankingInfo) return <div>Loading banking info...</div>;

  return (
    <div className="row">
      <div className="col-xl-5 col-lg-5 col-md-12">
        <div className="card">
          <div className="card-body">
            <div className="buy-sell-widget">
              <TabContent activeTab={"1"}>
                <TabPane tabId="1">
                  <form>
                    <Row>
                      <Col xs={6}>
                        <div className="form-group">
                          <label>{t("i.want.to.buy.label")}</label>
                          <Dropdown
                            id="buyCurrency"
                            name="buyCurrency"
                            value={formState.buyCurrency}
                            options={countries}
                            onChange={(e) =>
                              setFormState({
                                ...formState,
                                buyCurrency: e.value,
                              })
                            }
                            optionLabel="currencyName"
                            optionValue="currencyCode"
                            className="w-100"
                            filter
                            filterBy="currencyName"
                            placeholder="Select"
                            valueTemplate={valueTemplate}
                            itemTemplate={itemTemplate}
                          />
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div className="form-group">
                          <label>{t("i.want.to.sell.label")}</label>
                          <Dropdown
                            id="sellCurrency"
                            name="sellCurrency"
                            value={formState.sellCurrency}
                            options={countries}
                            onChange={(e) =>
                              setFormState({
                                ...formState,
                                sellCurrency: e.value,
                              })
                            }
                            optionLabel="currencyName"
                            optionValue="currencyCode"
                            className="w-100"
                            filter
                            filterBy="currencyName"
                            placeholder="Select"
                            valueTemplate={valueTemplate}
                            itemTemplate={itemTemplate}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6}>
                        <div className="form-group">
                          <label>{t("buy.amount.label")}</label>
                          <input
                            type="text"
                            name="buyAmount"
                            className="form-control"
                            placeholder={`100${
                              formState.buyCurrency
                                ? " " +
                                  t(`${formState.buyCurrency}.currency.label`)
                                : ""
                            }`}
                            value={formState.buyAmount}
                            onChange={handleChange}
                          />
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div className="form-group">
                          <label>{t("sell.amount.label")}</label>
                          <input
                            type="text"
                            name="sellAmount"
                            className="form-control"
                            placeholder={`100${
                              formState.sellCurrency
                                ? " " +
                                  t(`${formState.sellCurrency}.currency.label`)
                                : ""
                            }`}
                            value={formState.sellAmount}
                            onChange={handleChange}
                          />
                        </div>
                      </Col>
                    </Row>

                    <div className="form-group">
                      <label>{t("payment.method.label")}</label>
                      <select
                        className="form-control"
                        name="paymentMethod"
                        value={formState.paymentMethod}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        {paymentCards.map((card) => (
                          <option
                            key={card.id}
                            value={`${card.brand} **** ${card.last4}`}
                          >
                            {`${card.brand} **** ${card.last4} (exp: ${card.expMonth}/${card.expYear})`}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label>{t("deposit.account.label")}</label>
                      <select
                        className="form-control"
                        name="depositAccountId"
                        value={formState.depositAccountId}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        {depositAccounts.map((account) => (
                          <option
                            key={account.bankAccountId}
                            value={`${
                              account.bankName
                            } ****${account.accountNumber?.slice(-4)}`}
                          >
                            {`${
                              account.bankName
                            } ****${account.accountNumber?.slice(-4)}`}
                          </option>
                        ))}
                      </select>
                    </div>

                    <button
                      type="button"
                      className="btn btn-success btn-block"
                      onClick={handlePostOrder}
                    >
                      {t("post.my.order.label")}
                    </button>
                  </form>
                </TabPane>
              </TabContent>
            </div>
          </div>
        </div>
      </div>

      <div className="col-xl-7 col-lg-7 col-md-12">
        <div className="card">
          <div className="card-body">
            <div className="buyer-seller">
              <h4>{t("your.post.summary.label")}</h4>
              <table className="table">
                <tbody>
                  <tr>
                    <td>{t("you.want.to.buy.label")}</td>
                    <td>
                      {formState.buyAmount}{" "}
                      {formState.buyCurrency
                        ? " " + t(`${formState.buyCurrency}.currency.label`)
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td>{t("you.want.to.sell.label")}</td>
                    <td>
                      {formState.sellAmount}{" "}
                      {formState.sellCurrency
                        ? " " + t(`${formState.sellCurrency}.currency.label`)
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td>{t("payment.method.label")}</td>
                    <td>{formState.paymentMethod}</td>
                  </tr>
                  <tr>
                    <td>{t("deposit.account.label")}</td>
                    <td>{formState.depositAccountId}</td>
                  </tr>
                  <tr>
                    <td>{t("fee.label")}</td>
                    <td>
                      ${fee.toFixed(2)}{" "}
                      {formState.sellCurrency
                        ? " " + t(`${formState.sellCurrency}.currency.label`)
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td>{t("total.label")}</td>
                    <td>
                      ${total.toFixed(2)}{" "}
                      {formState.sellCurrency
                        ? " " + t(`${formState.sellCurrency}.currency.label`)
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td>{t("sub.total.label")}</td>
                    <td>
                      ${total.toFixed(2)}{" "}
                      {formState.sellCurrency
                        ? " " + t(`${formState.sellCurrency}.currency.label`)
                        : ""}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostComponent;
